export const think_mark_methods = {
  // ここで定義したメソッドはコンポーネント内からも使える
  think_mark_func1() {
    alert("think_mark_func1")
  },
}
